import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { layoutStyles } from "../core/layout";
import * as Icons from "../icons";
const anchorize = children => {
  if (typeof children === "string") {
    return children.toLowerCase().replace(/[ _]+/g, "-").replace(/[!:^*./\\]/g, "");
  } else {
    return undefined;
  }
};
function Heading(Component) {
  return function Heading(props) {
    const {
      children,
      ...rest
    } = props;
    const id = anchorize(children);
    return <Component {...rest} id={id}>
        <a className="x1heor9g x1hl2dhg xbok0fy x158d8ml x1rb6emv x1xi2g7t" href={id && `#${id}`}>
          {children}
          <Icons.Link className="x1rg5ohu x16vho4v xvgvpxu x1pazyae x1y6pbyt xxymvpz x2r93rw x1i3gk9 xo5ics5 x6ah1hw" />
        </a>
      </Component>;
  };
}
const h11 = props => <h1 {...stylex.props(layoutStyles.block, styles.h1)} {...props} />;
export { h11 as h1 };
const h21 = Heading(props => <h2 {...stylex.props(layoutStyles.block, styles.h2)} {...props} />);
export { h21 as h2 };
const h31 = Heading(props => <h3 {...stylex.props(layoutStyles.block, styles.h3)} {...props} />);
export { h31 as h3 };
const h41 = Heading(props => <h4 {...stylex.props(layoutStyles.block, styles.h4)} {...props} />);
export { h41 as h4 };
const blockquote1 = props => {
  const {
    children,
    ...rest
  } = props;
  return <blockquote {...rest} {...stylex.props(layoutStyles.block, styles.blockquote)}>
      {React.Children.toArray(children).filter(x => x !== "\n").map((child, index, self) => {
      if (!React.isValidElement(child)) {
        return child;
      }
      const style = {
        marginTop: index === 0 ? "0" : undefined,
        marginBottom: index === self.length - 1 ? "0" : undefined
      };
      return React.cloneElement(child, {
        style
      });
    })}
    </blockquote>;
};
export { blockquote1 as blockquote };
const hr1 = props => <hr {...stylex.props(layoutStyles.block, styles.hr)} {...props} />;
export { hr1 as hr };
const table1 = props => <table {...stylex.props(layoutStyles.block, styles.table)} {...props} />;
export { table1 as table };
const thead1 = props => <thead {...props} />;
export { thead1 as thead };
const tbody1 = props => <tbody {...props} />;
export { tbody1 as tbody };
const tr1 = props => <tr className="x83z2og x178xt8z x13fuv20 x1r4gg6b x7kswos" {...props} />;
export { tr1 as tr };
const th1 = props => {
  const {
    align,
    ...rest
  } = props;
  const style = {
    textAlign: align || "center"
  };
  return <th className="x12ek6fo xmkeg23 x1y0btm7 x1kgrkcs" style={style} {...rest} />;
};
export { th1 as th };
const td1 = props => {
  const {
    align,
    ...rest
  } = props;
  const style = {
    textAlign: align || "left"
  };
  return <td className="x12ek6fo xmkeg23 x1y0btm7 x1kgrkcs" style={style} {...rest} />;
};
export { td1 as td };
const code1 = props => <code className="x1sxf85j x1jnxms5 xsfzzmd xbspb1j xmkeg23 x1y0btm7 xj7gikm x1vhptj2" {...props} />;
export { code1 as code };
const a1 = props => <a className="x15rks2t x1hl2dhg x11p4203 x1j43nte xodwsf6 x1w3jsh0 xlan1bs x1v02d47 x1k07x2j x15m0p1m x1bezv82" {...props} />;
export { a1 as a };
const p1 = props => <p {...stylex.props(layoutStyles.block)} {...props} />;
export { p1 as p };
const ul1 = props => <ul {...stylex.props(layoutStyles.block)} {...props} />;
export { ul1 as ul };
const ol1 = props => <ol {...stylex.props(layoutStyles.block)} {...props} />;
export { ol1 as ol };
const button1 = props => <button className="x1a2a7pz xmkeg23 x1y0btm7 xj7gikm x1cum3z5 x1d0dlzq x1cdhzux xln7xf2 xo5v014 x1whlmpv x1k49i25 x49kzi4 x1dc5b4e x13m658e x1bx2y69" {...props} />;
export { button1 as button };
const styles = {
  h1: {
    keoZOQ: "x1hpjnmm",
    k1K539: "xyi6m4r",
    kGuDYH: "x579bpy",
    kLWn49: "x2sqz4w",
    k63SB2: "xkjxd12",
    kTHuQy: "xcaxn08",
    $$css: true
  },
  h2: {
    kVAEAm: "x1n2onr6",
    kogj98: "xgv6dkq",
    kGuDYH: "xngnso2",
    kLWn49: "x1gst2wd",
    k63SB2: "xkjxd12",
    $$css: true
  },
  h3: {
    kVAEAm: "x1n2onr6",
    kogj98: "x2ijy0e",
    kGuDYH: "x1lkfr7t",
    kLWn49: "x1c40qdn",
    k63SB2: "xkjxd12",
    $$css: true
  },
  h4: {
    kVAEAm: "x1n2onr6",
    kogj98: "x2ijy0e",
    kGuDYH: "x6u19be",
    kLWn49: "x1k2ygyi",
    k63SB2: "xkjxd12",
    $$css: true
  },
  hr: {
    k1xSpc: "x1lliihq",
    ksu8eU: "xng3xce",
    kZKoxP: "xjm9jq1",
    kzqmXN: "xh8yej3",
    kWkggS: "xtwfq29",
    kSiTet: "xvpkmg4",
    $$css: true
  },
  table: {
    kheTzg: "x1gukg7c",
    kLvRdT: "x1mwwwfo",
    kzqmXN: "xh8yej3",
    kVQacm: "xysyzu8",
    $$css: true
  },
  blockquote: {
    koQZXg: "xj3b58b",
    kGuDYH: "x1hptrd9",
    $$css: true
  }
};